interface Props {
  createdAt: string;
}

function daysSince(iso: string): number {
  const ms = Date.now() - new Date(iso).getTime();
  return Math.max(0, Math.floor(ms / (24 * 60 * 60 * 1000)));
}

export function ListingFreshness({ createdAt }: Props) {
  const days = daysSince(createdAt);

  let label: string;
  let classes: string;
  let icon: React.ReactNode;

  if (days <= 1) {
    label = days === 0 ? "Naujas šiandien" : "Naujas vakar";
    classes = "bg-emerald-50 text-emerald-700 ring-emerald-200";
    icon = (
      <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    );
  } else if (days <= 7) {
    label = `Paskelbta prieš ${days} d.`;
    classes = "bg-gray-50 text-gray-700 ring-gray-200";
    icon = (
      <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    );
  } else if (days <= 30) {
    label = `Paskelbta prieš ${days} d. — pasitikslink, ar dar prieinamas`;
    classes = "bg-amber-50 text-amber-800 ring-amber-200";
    icon = (
      <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    );
  } else {
    const months = Math.floor(days / 30);
    label = `Senesnis nei ${months} mėn. — gali būti nebeaktyvus`;
    classes = "bg-amber-50 text-amber-800 ring-amber-200";
    icon = (
      <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${classes}`}
    >
      {icon}
      {label}
    </span>
  );
}
